import { render, staticRenderFns } from "./UcMeterValidityCard.yaml?vue&type=template&id=35b96874&component"
import script from "./UcMeterValidityCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcMeterValidityCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports